import ToolTip from '../../ToolTip/ToolTip';
import defaultImage from '../../../../src/img/courses/courseDefaultImage.webp'; // Default image for missing course image
import { Icon } from '@iconify/react/dist/iconify.js';
import { Active, Inactive } from '../Common Icons/Icons';
import { Avatar, Box, IconButton } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ViewOptions from './ViewOptions';

const renderDefault = (value, fallback = 'Nill') => value || fallback;

const renderCourseImage = (params) => (
  <Box sx={{ margin: 2 }}>
    <Avatar
      sx={{ height: 50, width: 50 }}
      key={params.row.sl_no}
      src={params.row.img || defaultImage}
      alt="course Image"
    />
  </Box>
);

const renderDescription = (params) => (
  <ToolTip expand={params?.row?.courseOutcomes || 'Nill'} content={params?.row?.courseOutcomes || 'Nill'} />
);

const renderClassType = (params) => (params.row.batchAvailability === 1 ? 'Group' : 'Individual');

const renderCourseStatus = (params) => (params.row.courseAvailability === 1 ? <Active /> : <Inactive />);

const RenderCourseOptions = (params) => {
  return <ViewOptions data={params.row.options} />;
};

export const courseTableHeaderFn = (setOpenAddCourseDescript) => [
  { field: 'sl_no', headerName: 'Serial No', width: 80 },
  {
    field: 'courseImg',
    headerName: 'Image',
    width: 100,
    renderCell: renderCourseImage,
  },
  { field: 'courseName', headerName: 'Course Name', width: 300 },
  { field: 'projectName', headerName: 'Project Name', width: 150 },
  {
    field: 'price_per_session',
    headerName: 'Price Per Session',
    width: 150,
    renderCell: (params) => renderDefault(params.row.price_per_session),
  },
  {
    field: 'courseOutcomes',
    headerName: 'Description',
    width: 200,
    renderCell: renderDescription,
  },
  {
    field: 'batchAvailability',
    headerName: 'Class Type',
    width: 120,
    renderCell: renderClassType,
  },
  {
    field: 'courseAvailability',
    headerName: 'Course Current Status',
    width: 180,
    renderCell: renderCourseStatus,
  },
  {
    field: 'courseOptions',
    headerName: 'Course Options',
    width: 180,
    renderCell: RenderCourseOptions,
  },
  {
    field: 'Description',
    headerName: 'Description',
    width: 180,
    renderCell: ({ row }) => (
      <IconButton onClick={() => setOpenAddCourseDescript(row)}>
        <EditNoteIcon />
      </IconButton>
    ),
  },
];
